import { Button } from "@mui/material";
import React from "react";

interface FullNotesButtonProps {
  onClick: () => void;
}

export function FullNotesButton(props: FullNotesButtonProps) {
  const { onClick } = props;

  return (
    <Button
      id="notes-button"
      onClick={onClick}
      sx={{
        borderRadius: "30px",
        background: "#E5E9ED",
        px: "10px",
        py: "5px",
        color: "black",
        textTransform: "none",
        fontSize: "12px",
        lineHeight: { xs: "14px", sm: "16px" },
      }}
    >
      Open Full Notes
    </Button>
  );
}
